export function getCdnOrigin() {
  const host = window.location.host.split(".");
  const thirdLevelDomain = host.shift();

  return `https://${thirdLevelDomain === "fr" ? "cdn-fr" : "cdn"}.${host.join(".")}`;
}

/* eslint-disable camelcase */
if (__PRODUCTION__) {
  __webpack_public_path__ = getCdnOrigin() + "/";
} else {
  __webpack_public_path__ = "/";
}

const originalLoad = __webpack_chunk_load__;

__webpack_chunk_load__ = async (chunkId) => {
  return originalLoad(chunkId).catch(async (e) => {
    if (__PRODUCTION__) {
      const oldPublicPath = __webpack_public_path__;
      // Set public path to local server, if it is a CDN problem
      __webpack_public_path__ = "/";
      try {
        return await originalLoad(chunkId);
      } finally {
        // Always restore the public path, even if local load fails
        __webpack_public_path__ = oldPublicPath;
      }
    } else {
      throw e;
    }
  });
};
